import { match, P } from 'ts-pattern';
import { ActivityCard } from './ActivityCard';
import { ActivityMessagingPreviewProps } from '../activity-messaging/ActivityMessagingPreview.tsx';
import { ActivityMessagingType } from '../activity-messaging/ActivityMessagingPreview.types.ts';
import IconInterkabSolutions from '../../icons/IconInterkabSolutions.tsx';
import IconLbi from '../../icons/IconLbi.tsx';
import IconHektor from '../../icons/IconHektor.tsx';

export function ActivityCardHeaderUserFactory({
  type,
}: Pick<ActivityMessagingPreviewProps, 'type'>) {
  return (
    <ActivityCard.Header.User>
      {match({ type: type })
        .with(
          {
            type: P.union(ActivityMessagingType.SHOP, ActivityMessagingType.SHOP_IMAGE),
          },
          () => (
            <div className="flex size-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-b from-brand to-green-marketing">
              <IconLbi className="size-6 text-white" />
            </div>
          ),
        )
        .with(
          {
            type: P.union(ActivityMessagingType.INTERKAB_SOLUTIONS),
          },
          () => <IconInterkabSolutions className="w-25 h-10" />,
        )
        .otherwise(() => (
          <IconHektor className="size-9 text-brand" />
        ))}

      <ActivityCard.Header.User.Informations>
        <ActivityCard.Header.User.Informations.Name>
          {match({ type: type })
            .with(
              {
                type: P.union(
                  ActivityMessagingType.SHOP,
                  ActivityMessagingType.SHOP_IMAGE,
                ),
              },
              () => <span>Le Shop</span>,
            )
            .with(
              {
                type: ActivityMessagingType.INFO_LBI,
              },
              () => <span>La Boîte Immo</span>,
            )
            .with(
              {
                type: ActivityMessagingType.INTERKAB_SOLUTIONS,
              },
              () => null,
            )
            .otherwise(() => (
              <span>Hektor</span>
            ))}
        </ActivityCard.Header.User.Informations.Name>

        <ActivityCard.Header.User.Informations.Description>
          {match({ type: type })
            .with(
              {
                type: P.union(
                  ActivityMessagingType.SHOP,
                  ActivityMessagingType.SHOP_IMAGE,
                ),
              },
              () => 'Commandez vos supports de communication personnalisés !',
            )
            .with(
              {
                type: ActivityMessagingType.INFO_LBI,
              },
              () => '1er partenaire des agents immobiliers indépendants.',
            )
            .with(
              {
                type: P.union(ActivityMessagingType.INTERKAB_SOLUTIONS),
              },
              () => null,
            )
            .otherwise(() => 'Logiciel immobilier N°1 des agences indépendantes')}
        </ActivityCard.Header.User.Informations.Description>
      </ActivityCard.Header.User.Informations>
    </ActivityCard.Header.User>
  );
}
